import { dataHooks } from '@wix/data-hooks'

export const wixMobileStepProgressBarDataHooks = dataHooks<{
  step: { number: number; isActive: boolean }
}>('wix-mobile-step-progress-bar')
